import PrintServerList from "./components/PrintServerList.vue";
import PrintServerEdit from "./components/PrintServerEdit.vue";
import PrintServerView from "./components/PrintServerView.vue";

export default {
    PrintServerList,
    PrintServerEdit,
    PrintServerView,
};
